/* projects/common-module/src/lib/aur-datepicker/calendar/aur-calendar.component.scss */
button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 36px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}
button:hover:not(.disabled):not(:disabled) {
  background-image: linear-gradient(color-mix(in srgb, currentColor 10%, transparent), color-mix(in srgb, currentColor 10%, transparent));
}
button:active:not(.disabled):not(:disabled) {
  background-image: linear-gradient(color-mix(in srgb, currentColor 16%, transparent), color-mix(in srgb, currentColor 16%, transparent));
}
button.in-range {
  background-color: var(--aur-calendar-range-background, #eef3fa);
  border-radius: 4px;
}
button.selected {
  background-color: var(--aur-calendar-primary, #2b5f9e);
  color: var(--aur-calendar-on-primary, #ffffff);
  font-weight: 600;
  border-radius: 8px;
}
button.disabled {
  color: var(--aur-calendar-disabled-text, #a7aebd);
  background-color: var(--aur-calendar-disabled-background, transparent);
  cursor: default;
}
button:focus-visible {
  outline: 2px solid var(--aur-calendar-focus, #235081);
  outline-offset: 2px;
}
:host {
  display: block;
  width: 100%;
  min-width: 264px;
  color: var(--aur-calendar-text, #1d222c);
  background-color: var(--aur-calendar-background, #ffffff);
  font-family: var(--aur-calendar-font-family, "Inter Tight", "Helvetica Neue", Helvetica, system-ui, sans-serif);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}
table {
  display: block;
  width: 100%;
  border-collapse: collapse;
}
thead,
tbody {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
thead {
  margin-bottom: 4px;
}
tr {
  display: flex;
  gap: 2px;
}
th,
td {
  flex: 1 1 0;
  min-width: 0;
  padding: 0;
  text-align: center;
}
th {
  height: 20px;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  color: var(--aur-calendar-muted-text, #687386);
}
button,
.empty-day {
  height: 36px;
}
button {
  width: 36px;
  max-width: 100%;
  margin-inline: auto;
  border-radius: 999px;
}
button.today:not(.selected) {
  box-shadow: inset 0 0 0 1px var(--aur-calendar-today-border, #bcd0e8);
  border-radius: 4px;
}
button.range-start:not(.range-end) {
  border-radius: 8px 0 0 8px;
}
button.range-end:not(.range-start) {
  border-radius: 0 8px 8px 0;
}
button.has-content {
  width: 100%;
  height: auto;
  min-height: 36px;
  padding: 4px 0;
  flex-direction: column;
  justify-content: flex-start;
}
.empty-day {
  display: block;
}
.day-content {
  display: block;
  max-width: 100%;
  font-weight: 400;
  overflow-wrap: anywhere;
}
@media (max-width: 600px) {
  button {
    width: 44px;
    max-width: 100%;
    height: 44px;
    margin-inline: auto;
  }
  button.has-content {
    max-width: none;
    min-height: 44px;
    height: auto;
  }
  .empty-day {
    height: 44px;
  }
  :host(.compact-on-small-screens) .empty-week {
    display: none;
  }
}
:host(.mobile-layout) button {
  width: 44px;
  max-width: 100%;
  height: 44px;
  margin-inline: auto;
}
:host(.mobile-layout) button.has-content {
  max-width: none;
  min-height: 44px;
  height: auto;
}
:host(.mobile-layout) .empty-day {
  height: 44px;
}
:host(.mobile-layout.compact-on-small-screens) .empty-week {
  display: none;
}
/*# sourceMappingURL=aur-calendar.component.css.map */
